import {IAvukatDosya} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";
import {
    TamamlanmayanDosyalar,
    TamamlanmayanDosyalarRow,
    TamamlanmayanDosyaTurKod
} from "@/plugins/uyap-plugin/uyap/TamamlanmayanDosyalar";

const TOLERANCE_MS = 1000; // açılış tarihi kaymaları için 1sn'li tolerans

export class TamamlanmayanDosyaBul {
    err: any = {};
    tamamlanmayanDosyalar: Array<TamamlanmayanDosyalarRow> = []

    constructor() {
        this.err = {message: "Dosya Bulunamadı."};
    }

    async getMockResponse(): Promise<IAvukatDosya> {
        let adsg = new TamamlanmayanDosyalar();
        let data = await adsg.parse(adsg.getMockResponse());
        // @ts-ignore
        return data[0];
    }

    async run(dosya: { birimId: string, acilisTime: number, dosyaAcilisTarihi: any }, isMTS: boolean = false): Promise<TamamlanmayanDosyalarRow> {
            try {
                if (isMTS)
                    this.tamamlanmayanDosyalar = await new TamamlanmayanDosyalar().run({dosyaTurKod: TamamlanmayanDosyaTurKod.MTS});
                else
                    this.tamamlanmayanDosyalar = await new TamamlanmayanDosyalar().run({dosyaTurKod: TamamlanmayanDosyaTurKod.NORMAL});

                let bulunanDosya;
                if(isMTS){
                    bulunanDosya = this.tamamlanmayanDosyalar.find(tamamlanmayanDosya => {
                        const tarih1 = new Date(tamamlanmayanDosya.dosyaAcilisTarihi); // örneğin: "Jun 11, 2025 12:56:29 PM"

                        // Avrupa formatı: "11/06/2025 12:56:29"
                        const [gun, ay, yil, saat] = dosya.dosyaAcilisTarihi.match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}:\d{2}:\d{2})/).slice(1);
                        const tarih2 = new Date(`${yil}-${ay}-${gun}T${saat}`);
                        //console.log("tarih 1",tarih1);
                        //console.log("tarih 2",tarih2);
                        return (
                            tamamlanmayanDosya.birimID == dosya.birimId &&
                            Math.abs(tarih1.getTime() - tarih2.getTime()) <= TOLERANCE_MS
                        );
                    });
                }else{
                    bulunanDosya = this.tamamlanmayanDosyalar.find(tamamlanmayanDosya => (
                        tamamlanmayanDosya.birimID == dosya.birimId &&
                        Math.abs(new Date(tamamlanmayanDosya.dosyaAcilisTarihi).getTime() - dosya.acilisTime) <= TOLERANCE_MS
                    ))
                }
                console.log("bulunan Dosya",bulunanDosya);
                if (!bulunanDosya)
                    throw new Error('Dosya Bulunamadı.')
                return bulunanDosya;
            } catch (e) {
                console.log("TAMAMLANMAYAN DOSYA BULUNAMADI",e);
                throw new Error(e.message);
            }
    }

    runToplu(dosyalar: Array<{
        birimId: string,
        acilisTime: number
    }>, isMTS: boolean = false): Promise<Array<TamamlanmayanDosyalarRow>> {
        return new Promise(async (resolve, reject) => {
            try {
                if (isMTS)
                    this.tamamlanmayanDosyalar = await new TamamlanmayanDosyalar().run({dosyaTurKod: TamamlanmayanDosyaTurKod.MTS});
                else
                    this.tamamlanmayanDosyalar = await new TamamlanmayanDosyalar().run({dosyaTurKod: TamamlanmayanDosyaTurKod.NORMAL});
                let filteredDosyalar = this.tamamlanmayanDosyalar.filter(tamamlanmayanDosya => {
                    let dosyaTime = new Date(tamamlanmayanDosya.dosyaAcilisTarihi).getTime();
                    let birimId = tamamlanmayanDosya.birimID;
                    return !!dosyalar.find(dosya=> (
                        dosya.birimId == birimId &&
                        Math.abs(dosya.acilisTime - dosyaTime) <= TOLERANCE_MS
                    ));
                })
                return resolve(filteredDosyalar);
            } catch (e) {
                return reject(e);
            }
        });
    }
}

